"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(["\n  bottom: ", ";\n"], ["\n  bottom: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-size: 1.5em;\n  font-style: italic;\n  left: 0;\n  position: absolute;\n  width: 100%;\n"], ["\n  ", ";\n  color: ", ";\n  font-size: 1.5em;\n  font-style: italic;\n  left: 0;\n  position: absolute;\n  width: 100%;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  left: 0;\n  right: 0;\n  text-align: center;\n"], ["\n  left: 0;\n  right: 0;\n  text-align: center;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"], ["\n  ", ";\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  height: 50%;\n"], ["\n  height: 50%;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  top: 50%;\n"], ["\n  padding-top: ", ";\n  top: 50%;\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n"], ["\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  top: ", ";\n  transform: ", ";\n"], ["\n  top: ", ";\n  transform: ", ";\n"]);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Absolute = require("../Absolute");

var _Absolute2 = _interopRequireDefault(_Absolute);

var _propTypes = require("../../constants/propTypes");

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var IconWrap = (0, _styledComponents2.default)(_Absolute2.default)(_templateObject, function (props) {
  return !props.isAlone ? 0 : undefined;
});

var MessageWrap = _styledComponents2.default.div(_templateObject2, c.fontSmoothing(), c.GRAY);

var Partial = (0, _styledComponents2.default)(_Absolute2.default)(_templateObject3);

var Wrap = _styledComponents2.default.div(_templateObject4, c.overlay('fixed')); //


var Panel = (0, _styledComponents2.default)(Partial)(_templateObject5); //

var Bottom = (0, _styledComponents2.default)(Panel)(_templateObject6, function (props) {
  return props.isAlone ? undefined : '1em';
});
var FlyerMessage = (0, _styledComponents2.default)(Partial)(_templateObject7);
var Top = (0, _styledComponents2.default)(Panel)(_templateObject8, function (props) {
  return props.vertical ? '50%' : '0';
}, function (props) {
  return props.vertical ? 'translateY(-50%)' : undefined;
}); //

var Flyer = function Flyer(props) {
  var hasIcon = !!(props.icon || props.customIcon);
  var hasMessage = !!props.message;
  var topIsAlone = hasIcon && !hasMessage;
  var bottomIsAlone = !hasIcon && hasMessage;
  return _react2.default.createElement(Wrap, null, !bottomIsAlone && _react2.default.createElement(Top, {
    vertical: topIsAlone
  }, _react2.default.createElement(IconWrap, {
    horizontal: true,
    isAlone: topIsAlone,
    vertical: topIsAlone
  }, props.customIcon || _react2.default.createElement(_Icon2.default, _extends({}, (0, _propTypes.colorProps)(props), {
    icon: props.icon
  })))), !topIsAlone && _react2.default.createElement(Bottom, {
    isAlone: bottomIsAlone
  }, _react2.default.createElement(MessageWrap, null, props.message && _react2.default.createElement(FlyerMessage, null, props.message))));
};

Flyer.defaultProps = _propTypes2.flyerDefaultProps;
Flyer.propTypes = _propTypes2.flyerPropTypes;
exports.default = Flyer;